export default __webpack_public_path__ + "static/media/무당주술에 대적 불 기도 copy.a378ee3c.jpg";